import StatusHistory from "./StatusHistory.component.jsx";

export default StatusHistory;